function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/_opy_VqP/0/cw/ws/uvocorp.com/gatsby/~/@babel/runtime/helpers/interopRequireDefault.js
// module id = 58
// module chunks = 35783957827783 231608221292675